import { call, takeLatest, select } from 'redux-saga/effects'
import { actionTypes } from '../actions/tableQrcodeActions'
import { sendRequest } from '../services/apiService'
import apiConfig from '../constants/apiConfig'

function* _answerQuestion({ payload: { params, onDone } }) {
    const { tokenOrderForWeb } = yield select(state => state.OrderReducer)

    const options = { ...apiConfig.order.answerQuestion }
    options.headers.Authorization = `Bearer ${tokenOrderForWeb}`
    yield call(sendRequest, options, params)
    onDone && onDone()
}

const sagas = [
    takeLatest(actionTypes.ANSWER_QUESTION, _answerQuestion),
]

export default sagas
